import React, { useState } from "react";
import { ChevronLeft, Bicycle, BookmarkCheckFill } from "react-bootstrap-icons";
import AccardionItem from "../Accardion/AccardionItem/AccardionItem";
import Style from "./Accardion9.module.scss";
const Accardion9 = () => {
  const [openOnClickList , setOpenOnClickList]=useState(false)
  const [openOnClickUser , setOpenOnClickUser]=useState(false)
  const [openAll , setOpenAll]=useState(false)

  const ItemList = [
    {
      id: "1",
      title: "افزودن برند",
      link: "/addbrand",
      active: window.location.pathname === "/addbrand",
    },
    {
      id: "2",
      title: "لیست برندها",
      link: "/brandlist",
      active: window.location.pathname === "/brandlist",
    },

  ];

  let value = false;
  ItemList.forEach((element) => {
    if (element.active) {
      value = true;
    }
  });



  const openHandlerAll=()=>{
    if(openAll){
      setOpenAll(false)
    }
    else{
      setOpenAll(true)
    }
  }
  return (
    <div className={Style.componentHolder}>
      <div
        className={value || openAll ? Style.background : Style.accardionTitle}
        onClick={openHandlerAll}
      >
        <ChevronLeft />
        <div className={Style.right}>
          <p className={Style.accardionText}>برند </p>
          <BookmarkCheckFill />
        </div>
      </div>
      <div className={value ||openAll ? Style.inneraccardionContent : Style.hidden}>
        <AccardionItem accardonItem={ItemList && ItemList} />
      </div>
    </div>
  );
};

export default Accardion9;
